import log from '../../core/log';
// import waitForImages from 'jquery.waitforimages';
import { animate } from '../../core/animations';
// import FilteringMenu from '../../components/filtering-sorting/FilteringMenu';
import FilteringSorting from '../../components/filtering-sorting/FilteringSorting';
import { saveFilterState, applyFilterState, willRefetchOnApply, getPendingFilterState, getSortingState, getPaginationState } from '../../components/filtering-sorting/filterState';
import productTileTemplate from './productTileTemplateNosto';
import keepSameHeightTitles from './keepSameHeightTitles';
import structuredData from './structuredData';
import NostoCollections from '../../components/nosto/collections';
import ShopifyCollection from '../../components/nosto/fallback';
// import applyShopifyMarket from '../../components/nosto/applyShopifyMarket';
// import loadProductsByID from '../../core/storefrontAPI/load-product-by-id';
// import loadCachedColorFamilies from '../../components/data-caching/loadCachedColorFamilies';
import SuggestionsSearch from '../../components/overlay-search-nosto/suggestions-search';
import { noResults, removeNoResults, loadFailed, removeLoadFailed } from './noResults';
import recommendationListVisibility from './recommendationListVisibility';
import { removePlaceholders, removeMarketingBlocks, addPlaceholders, addMarketingBlocks, showPagination, initNumberedPagination, refreshOptions, removeProductTiles } from './actions';
import { isRestoringPlpScroll } from './scrollRestore';
import retrieveSelectedFilters from '../../components/filtering-sorting/retrieveSelectedFilters';
import { updatePageInUrl } from '../../components/filtering-sorting/filterURL';
import { selectSwatch } from './selectNewColor';
import addPaginationTileToLastRow from './lastRowPaginationTile';
import { ABOVE_FOLD_TILES } from './gridLayout';

let filterInstance = null;
let collection_handle = '';
let collection_id = 0;
let products_json = null;
let filtered_products = [];
let filtered_products_search = [];
let filtered_products_paginated = [];
let per_page = Number(window.theme.collections.products_per_page);
// ASTR pagination (different from the Nosto pagination that starts at 0)
let current_page = 1;
let current_page_search = 1;
let current_total_products_shown = 0;
let current_total_products_shown_search = 0;
let nosto_nbHits = 0;
let nosto_nbHits_search = 0;
let NostoCollectionsObj = null;
let ShopifyCollectionObj = null;
// The filtered request started alongside the first one; { promise, signature } or null
let prefetched_filtered_request = null;
// Bumped on every full (non-append) grid render, so a deferred append can tell whether the
// grid it was going to append to is still the one on screen
let initial_render_token = 0;

/**
 * Resolve once the browser has had a chance to paint what was just inserted.
 *
 * requestAnimationFrame fires before the next paint, so the nested timeout lands just after it
 * — by which point layout has run and the images in those tiles have been discovered.
 *
 * Always raced against a timer: rAF is paused in background tabs, and without the race a PLP
 * opened in one would sit at four tiles until it was focused.
 *
 * @param {number} timeout_ms - Fallback deadline
 *
 * @returns {Promise<void>}
 */
const afterNextPaint = (timeout_ms = 250) => new Promise((resolve) => {
  let settled = false;
  let fallback_timer = null;

  const finish = () => {
    if (settled) {
      return;
    }

    settled = true;
    window.clearTimeout(fallback_timer);
    resolve();
  };

  fallback_timer = window.setTimeout(finish, timeout_ms);

  if (typeof window.requestAnimationFrame !== 'function') {
    return;
  }

  window.requestAnimationFrame(() => window.setTimeout(finish, 0));
});

/**
 * Identify a request by what it asks for, so a prefetched response is only consumed by a
 * request that wanted exactly the same thing.
 *
 * @param {Array} filtering - [[group, value], ...]
 * @param {string} sorting
 * @param {number} page
 *
 * @returns {string}
 */
const requestSignature = (filtering, sorting, page) => JSON.stringify({
  f: (filtering || []).map(pair => `${pair[0]}=${pair[1]}`).sort(),
  s: sorting,
  p: Number(page) || 1,
});

/**
 * Start the filtered request now instead of after the first one comes back.
 *
 * The two are only sequential by construction, not by dependency: the first supplies the full
 * facet list for the filter menu, the second the products, and both sets of parameters are
 * known up front. nostoRequest() builds its query synchronously from window.theme.collections,
 * so setting those globals around each call snapshots them independently.
 *
 * Nosto only — the Shopify fallback ignores filtering entirely, so there would be nothing to
 * prefetch.
 */
const prefetchFilteredRequest = () => {
  const nosto_enabled = window.theme.api.nosto.collection.enabled === true
    && window.theme.api.nosto.collection.current_collection_enabled === true;

  if (!nosto_enabled || NostoCollectionsObj === null) {
    return;
  }

  const pending = getPendingFilterState();
  if (pending === null) {
    return;
  }

  const current_filtering = window.theme.collections.filtering;
  const current_sorting = window.theme.collections.sorting;
  const current_page = window.theme.collections.page;

  window.theme.collections.filtering = pending.filtering;
  window.theme.collections.sorting = pending.sorting;
  window.theme.collections.page = pending.page;

  const promise = NostoCollectionsObj.nostoRequest();

  // Put the globals back for the unfiltered request loadCollection is about to build
  window.theme.collections.filtering = current_filtering;
  window.theme.collections.sorting = current_sorting;
  window.theme.collections.page = current_page;

  prefetched_filtered_request = {
    promise,
    signature: requestSignature(pending.filtering, pending.sorting, pending.page),
  };

  log('[ASTR] Filtered request started in parallel', prefetched_filtered_request.signature);
};

/**
 * The prefetched response, but only if it answers the question being asked.
 *
 * The prefetch is built from the saved state while selectNewFilter() reads the filter menu, and
 * the two can legitimately disagree — a saved filter whose option this collection has no facet
 * for never makes it into the DOM. Comparing signatures keeps that from silently serving the
 * wrong product set.
 *
 * @param {string} signature
 *
 * @returns {Promise|null}
 */
const takePrefetchedRequest = (signature) => {
  const prefetched = prefetched_filtered_request;
  prefetched_filtered_request = null;

  if (prefetched === null) {
    return null;
  }

  if (prefetched.signature !== signature) {
    log('[ASTR] Prefetched request discarded, parameters changed', prefetched.signature, signature);
    return null;
  }

  return prefetched.promise;
};

/* *** For search overlay ***/
const setFilteredProducts = (new_filtered_products) => {
  filtered_products_search = new_filtered_products;
};

const setNextPageSearch = (reset = false) => {
  current_page_search = (reset) ? 1 : current_page_search + 1;
};

const setNbHitsSearch = (new_nosto_nbHits_search) => {
  nosto_nbHits_search = new_nosto_nbHits_search;
};

const setCurrentPageSearch = (new_current_page_search) => {
  current_page_search = new_current_page_search;
  window.theme.search.page = current_page_search;
};

const getCurrentPageSearch = () => {
  return current_page_search;
};

const getCurrentPage = () => {
  return current_page;
};

/* *** End search overlay compatibility ****/

// We're not using regular pagination anymore since Algolia might send out of stock pinned products which we remove later from applyAvailabilityFilter() and we end up with less than per_page products
const getNextSetOfProducts = (page_reset = true, load_page = false) => {
  const from_search = document.body.classList.contains('has-overlay-search');
  // let total_pages = 1;
  // if (typeof load_page !== 'undefined') {
  //   total_pages = parseInt(load_page, 10);
  // }

  // const c_page = $('body').hasClass('has-overlay-search') ? current_page_search : current_page;
  const c_filtered_products = from_search ? filtered_products_search : filtered_products;
  let c_total_products_shown = 0;
  if (!page_reset) {
    c_total_products_shown = from_search ? current_total_products_shown_search : current_total_products_shown;
  }

  // const start = (c_page - 1) * per_page;
  // const end = (start + per_page) * total_pages;
  const start = c_total_products_shown;
  const end = c_filtered_products.length;
  if (from_search) {
    current_total_products_shown_search = c_filtered_products.length;
  } else {
    current_total_products_shown = c_filtered_products.length;
  }

  filtered_products_paginated = c_filtered_products.slice(start, end);

  log('getNextSetOfProducts', start, end, filtered_products_paginated, c_filtered_products.length);
};

/**
 * Build the product tiles from Nosto data and inject them to the grid
 * 
 * @param {boolean} append_content - If true, appends the content to the grid, otherwise replaces it
 * @param {boolean} from_search - If true, indicates that the function is called from the search overlay
 * @param {string} loading_type - The type of loading ('initial', 'initial-a', 'initial-b', 'filtering', 'pagination', 'search', 'search-pagination')
 *
 * @returns {Promise<void>} - Triggers 'astr-plp-tiles-built' event when complete
 */
const buildProductTiles = async (append_content, from_search = false, loading_type = '', called_from = '') => {
  // A full render replaces whatever is in the grid, which invalidates any append still waiting
  // its turn
  if (!append_content) {
    initial_render_token += 1;
  }

  return new Promise(async (resolve) => {
    if (!filtered_products_paginated.length) {
      resolve();
    }

    const prefix = (from_search) ? 'overlay-search-' : '';

    try {
      let start_increment = 0;

      // Render the above-fold tiles for the 1st PLP page on initial load, then on a second call
      // append the rest
      if (loading_type === 'initial-a') {
        filtered_products_paginated = filtered_products.slice(0, ABOVE_FOLD_TILES);
      } else if (loading_type === 'initial-b') {
        filtered_products_paginated = filtered_products.slice(ABOVE_FOLD_TILES);
        start_increment = ABOVE_FOLD_TILES;
      }

      const products_tiles_html = filtered_products_paginated.map((product, idx) => {
        let tile_index = start_increment + idx + 1 + ((window.theme.collections.page - 1) * window.theme.collections.products_per_page);
        let tile_position = (window.theme.collections.page > 1) ? (start_increment + idx + 1 + ((window.theme.collections.page - 1) * per_page)) : null; // adding 1 because order is 0 based
        if (from_search) {
          tile_index = idx + 1 + ((window.theme.search.page - 1) * window.theme.search.products_per_page);
          tile_position = (window.theme.search.page > 1) ? (idx + 1 + ((window.theme.search.page - 1) * per_page)) : null;
        }

        return productTileTemplate(product, {
          is_slider: false,
          is_simplified: false,
          has_swatches: true,
          has_quickview: true,
          has_animations: (from_search || window.theme.breakpoints.current === 'mobile') ? false : true,
          is_search: from_search,
          is_lookbook: false,
          enable_price_conversion: true,
          tile_index,
          position: tile_position
        });
      }).join('');

      // const grid_container = (from_search) ? document.querySelector('[data-overlay-search-results] .grid') : document.querySelector('[data-product-tiles] .grid');

      // if (grid_container) {
      //   (append_content) ? grid_container.insertAdjacentHTML('beforeend', products_tiles_html) : grid_container.innerHTML = products_tiles_html;
      // }

      if (from_search) {
        const grid_container = document.querySelector('[data-overlay-search-grid-container] .grid');

        if (grid_container) {
          // (append_content) ? grid_container.insertAdjacentHTML('beforeend', products_tiles_html) : grid_container.innerHTML = products_tiles_html;
          grid_container.innerHTML = products_tiles_html;
          grid_container.querySelectorAll(`[data-${prefix}total-filtered-items]`).forEach(el => el.classList.remove('hide'));
        }
      } else {
        const grid_container = document.querySelector('[data-product-tiles] .grid');

        if (grid_container) {
          if (append_content) {
            // Append the new product tiles
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = products_tiles_html;
            Array.from(tempDiv.childNodes).forEach(node => {
              grid_container.appendChild(node);
            });
          } else {
            removePlaceholders();
            removeMarketingBlocks();
            removeProductTiles();

            const total_filtered_items = grid_container.querySelectorAll(`[data-${prefix}total-filtered-items]`);
            if (total_filtered_items.length > 0) {
              total_filtered_items.forEach(el => el.classList.remove('hide'));
            }

            grid_container.insertAdjacentHTML('beforeend', products_tiles_html);
          }
        }
      }

      // await applyShopifyMarket((from_search) ? '[data-overlay-search-results]' : '[data-collection-grid-container]');
    } catch (error) {
      log(error);
    }

    const mobile_filter_nav = (from_search) ? document.querySelector('[data-overlay-search] [data-show-mobile-filter-nav]') : document.querySelector('[data-collection-grid-container] [data-show-mobile-filter-nav]');
    if (mobile_filter_nav) {
      mobile_filter_nav.classList.add('active');
      mobile_filter_nav.parentElement?.classList.add('active');
    }

    // const from_search = document.body.classList.contains('has-overlay-search');

    // Preselect the recommended color or 1st color swatch
    const tile_selector = from_search ? '[data-overlay-search-grid-container] [data-product-tile]' : '[data-collection-grid-container] [data-product-tile]';
    const init_tiles = Array.from(document.querySelectorAll(tile_selector)).filter(tile => !tile.classList.contains('init'));

    init_tiles.forEach(tile => {
      const color_swatch = tile.querySelectorAll('[data-color-swatch]');
      if (color_swatch.length > 0) {
        let swatch = color_swatch[0];
        const recommended_swatch = tile.querySelector('[data-color-swatch][data-is-recommended="true"]');

        if (recommended_swatch) {
          swatch = recommended_swatch;
        }

        selectSwatch(swatch);
      }
      tile.classList.add('init');
    });

    // updateLoadMoreButton();
    initNumberedPagination(nosto_nbHits_search, nosto_nbHits);

    // Dispatch events for new functionalities (init video tiles, etc.)
    const tiles_built_event = new CustomEvent('astr-plp-tiles-built', { bubbles: true });
    tiles_built_event.data = { from_search, filtered: ($(`[data-${prefix}selected-filters-item]`).length > 0) };
    document.dispatchEvent(tiles_built_event);

    if (!from_search) {
      // It's possible that due to marketing blocks or special rules (e.g. ambassador products), the last row of products is not full, in this case, we need to add a special product tile that links to the next page

      // console.log(`buildProductTiles(${called_from}) addPaginationTileToLastRow`, current_page, window.theme.collections.page);
      addPaginationTileToLastRow(nosto_nbHits, per_page);
    }

    keepSameHeightTitles();
    animate();

    resolve();
  });
};

/**
 * Load the original collection data. Either on first call or when a sorting event occurs
 * 
 * @param {boolean} is_sorting_event - If true, indicates that the function is called from a sorting event
 * 
 * @returns {Promise<void>} - Resolves when the collection is loaded
 */
const loadCollection = async (is_sorting_event = false) => {
  try {
    console.log('[ASTR] loadCollection', collection_handle, is_sorting_event);
    if (collection_handle === null || !collection_handle.length) {
      return;
    }

    const from_search = document.body.classList.contains('has-overlay-search');
    const prefix = (from_search) ? 'overlay-search-' : '';

    // Remove the "No results" / "couldn't load" divs if present
    removeNoResults();
    removeLoadFailed();

    // Page is always 1 when we trigger a sorting event (select new sort option)
    if (is_sorting_event) {
      if (from_search) {
        current_page_search = 1;
        window.theme.search.page = current_page_search;
      } else {
        current_page = 1;
        window.theme.collections.page = current_page;
        updatePageInUrl(current_page);
      }
    }

    // if (!window.theme.collections.page_split) {
    if (from_search) {
      const overlaySearchGridContainer = document.querySelector('[data-overlay-search-grid-container] .grid');
      if (overlaySearchGridContainer) {
        overlaySearchGridContainer.innerHTML = '';
      }
    } else {
      const collectionGridContainer = document.querySelector('[data-collection-grid-container] [data-show-mobile-filter-nav]');
      if (collectionGridContainer) {
        collectionGridContainer.classList.remove('active');
      }

      /*
      // We will just remove the product placeholders when the data is ready to be rendered
      const productTilesGrid = document.querySelector('[data-product-tiles] .grid');
      if (productTilesGrid) {
        productTilesGrid.innerHTML = '';
      }
      */

      const totalFilteredItems = document.querySelectorAll(`[data-${prefix}total-filtered-items]`);
      if (totalFilteredItems.length > 0) {
        totalFilteredItems.forEach(el => el.classList.add('hide'));
      }
    }
    // }

    window.theme.collections.sorting = getSortingState(true);

    // This function also gets called after selecting a new sorting option and filtering options might have been selected already
    // Extract the selected filter options
    const selected_filtering = retrieveSelectedFilters();

    // Set the page from the URL if present
    const urlParams = new URLSearchParams(window.location.search);
    const pageFromUrl = (from_search) ? parseInt(urlParams.get('spage'), 10) : parseInt(urlParams.get('page'), 10);

    if (from_search) {
      // window.theme.search.page = 1;
      window.theme.search.filtering = selected_filtering;
    } else {
      // window.theme.collections.page = 1;
      window.theme.collections.filtering = selected_filtering;
    }

    window.theme.collections.page = (!isNaN(pageFromUrl) && pageFromUrl > 0) ? pageFromUrl : 1;

    removeProductTiles();
    addPlaceholders();
    addMarketingBlocks();

    log('[ASTR] Initial Sorting:', window.theme.collections.sorting);
    log('[ASTR] Initial Filtering:', selected_filtering);

    // Saved filters / a saved page mean applyFilterState() will request again once the filter
    // menu exists. Start that request now so the two overlap instead of queueing.
    const will_refetch = !from_search && willRefetchOnApply();
    if (will_refetch) {
      prefetchFilteredRequest();
    }

    const nosto_collection = (window.theme.api.nosto.collection.enabled === true && window.theme.api.nosto.collection.current_collection_enabled === true) ? await NostoCollectionsObj.nostoRequest() : await ShopifyCollectionObj.shopifyRequest();
    // console.log('nosto_collection 2: ', nosto_collection);

    // null means the request errored or timed out — don't leave the shopper on placeholders
    if (nosto_collection === null) {
      removePlaceholders();
      loadFailed();
      return;
    }

    let nosto_products = [];

    if (typeof nosto_collection !== 'undefined' && nosto_collection !== null && typeof nosto_collection.products !== 'undefined' && nosto_collection.products !== null && nosto_collection.products.hits !== null && nosto_collection.products.hits.length > 0) {
      nosto_products = nosto_collection.products.hits;
    }

    const start_rendering = new Date();

    products_json = nosto_products;

    // We're on a collection page and a 3rd level URL is set (e.g. /collections/dresses/red)
    // Redirect to parent collection if we get less than 10 products
    if (window.localStorage.getItem('wild-third-level-url') !== null) {
      if (products_json === null || products_json.length < 10) {
        window.location.href = `/collections/${collection_handle}`;
        return;
      }
    }

    // No results
    if (products_json === null || products_json.length === 0) {
      noResults();
      refreshOptions(0);
      initNumberedPagination(nosto_nbHits_search, nosto_nbHits);

      // Hide the filters
      document.querySelector('.collection-grid-section')?.classList.add('no-results');

      document.querySelectorAll('[data-collection-grid-container] [data-show-mobile-filter-nav]').forEach(el => {
        el.style.display = 'none';
      });

      if (document.querySelector('[data-change-grid]')) {
        document.querySelectorAll('[data-change-grid-parent]').forEach(el => {
          el.style.display = 'none';
        });
      }

      return;
    }

    showPagination();

    window.theme.collections.facets = nosto_collection.products.facets ?? [];

    // getNextSetOfProducts(true);
    filtered_products = products_json;

    // Build the filter menu
    if (filterInstance === null && window.theme.collections.facets.length > 0) {
      filterInstance = new FilteringSorting();
      document.querySelectorAll('[data-filters-panel-v3]').forEach(el => {
        el.classList.add('loaded');
      });
    }

    // That same re-render means building tiles here would show the unfiltered collection for a
    // moment and then throw it away, so leave the placeholders up and let the filtered render
    // be the first one the shopper sees.
    const skip_initial_render = will_refetch;

    if (filtered_products.length) {
      getNextSetOfProducts(true);

      if (skip_initial_render) {
        log('[ASTR] Initial render skipped: filtered render is coming');
      } else if (from_search) {
        await buildProductTiles(false, from_search, 'initial', 'initialSearchPerformed');
      } else {
        await buildProductTiles(false, from_search, 'initial-a', 'initialSearchPerformed');

        // Hand the main thread back so the browser can lay out those first tiles and start
        // fetching their (eager) images before we spend ~250ms building the other 36. The old
        // 10ms timer rarely crossed a frame boundary, so both batches landed before any
        // resource pass and the split bought nothing.
        const render_token = initial_render_token;
        afterNextPaint().then(() => {
          // A newer full render (a filter click landing in the gap) owns the grid now
          if (render_token !== initial_render_token) {
            log('[ASTR] initial-b dropped: the grid was re-rendered underneath it');
            return;
          }

          return buildProductTiles(true, from_search, 'initial-b', 'initialSearchPerformed');
        });
      }

      showPagination();
    } else {
      noResults();
    }

    if (from_search) {
      nosto_nbHits_search = nosto_collection.products.total;
      initNumberedPagination(nosto_nbHits_search, nosto_nbHits);
    } else {
      structuredData(nosto_collection?.products?.hits || []);

      nosto_nbHits = nosto_collection.products.total;
      refreshOptions(nosto_nbHits);
      initNumberedPagination(nosto_nbHits_search, nosto_nbHits);

      // When coming back from a product page, or filtering querystring is in URL - ONLY
      // Note: this will re-trigger a Nosto API event. This is needed if we want to keep the same filter data from the original request.
      await applyFilterState(true);
      filterInstance?.updateAllFilterCounts?.();

      // If applyFilterState() didn't end up requesting, drop the prefetch rather than let it
      // sit around to be picked up by an unrelated filter click later
      prefetched_filtered_request = null;

      // Safety net for the skipped render: if the re-render we predicted never happened, the
      // shopper is sitting on placeholders. Render now rather than trust the prediction — the
      // worst case is then one wasted render, never an empty grid.
      if (skip_initial_render && !document.querySelector('[data-product-tiles] [data-product-tile]:not(.product-tile--placeholder)')) {
        log('[ASTR] Predicted filtered render never came; rendering the unfiltered grid');
        await buildProductTiles(false, from_search, 'initial-fallback', 'initialSearchPerformed');
        showPagination();
      }
      // Scroll restoration is driven by the 'astr-plp-tiles-built' event (see scrollRestore.js)
    }

    const end_rendering = new Date() - start_rendering;
    log(`Data rendered in ${end_rendering / 1000} seconds`);
  } catch (error) {
    console.log('[ASTR] loadCollection()', error);
  }
};

/**
 * Select a new filter from the nav
 * force_per_page used when coming back from the PDP
 * 
 * @param {boolean} save_filter_state - If true, saves the filter state
 * @param {number} saved_page - The page to load, used when coming back from the PDP
 * @param {string} force_sorting - The sorting option to use, if any
 * 
 * @returns {Promise<void>} - Resolves when the new filter is applied
 */
const selectNewFilter = async (save_filter_state = true, force_sorting = '', saved_page) => {
  console.log('[ASTR] selectNewFilter', save_filter_state, force_sorting, saved_page);
  const from_search = document.body.classList.contains('has-overlay-search');
  const prefix = (from_search) ? 'overlay-search-' : '';
  const is_save_filter_state = (from_search) ? false : save_filter_state;

  if (from_search) {
    current_page_search = 1;
    window.theme.search.page = current_page_search;
  } else {
    current_page = 1;
    window.theme.collections.page = current_page;
  }

  if (is_save_filter_state) {
    saveFilterState();
  }

  removeNoResults();
  removeLoadFailed();

  if (!from_search && typeof saved_page !== 'undefined') {
    log(`[wild-filter] saved_page: ${saved_page}`);
    current_page = saved_page;

    if (current_page <= 0) {
      current_page = 1;
    }

    window.theme.collections.page = current_page;
  }

  if (!from_search) {
    updatePageInUrl(current_page);
  }

  // Extract the selected options
  const selected_filtering = retrieveSelectedFilters();

  // Restore the sort by state
  if (force_sorting === '') {
    const sortingInput = document.querySelector(`[data-${prefix}sort-by] [data-value="${window.theme.collections.sorting}"] input`);
    if (sortingInput) {
      sortingInput.checked = true;
    }

    const mobileSortingInput = document.querySelector(`[data-mobile-${prefix}filter-sorting] [data-value="${window.theme.collections.sorting}"] input`);
    if (mobileSortingInput) {
      mobileSortingInput.checked = true;
    }
  }

  recommendationListVisibility(selected_filtering);

  const grid_container = (from_search) ? document.querySelector('[data-overlay-search-grid-container] .grid') : document.querySelector('[data-product-tiles] .grid');

  // Load the 1st page of Nosto data. It will be used as reference.
  let nosto_collection = null;

  if (from_search) {
    window.theme.search.filtering = selected_filtering;
    window.theme.search.page = 1;

    if (grid_container) {
      grid_container.innerHTML = '';
    }

    const suggestionsSearch = new SuggestionsSearch();
    await suggestionsSearch.nostoSearch(true);
    return;
  } else {
    window.theme.collections.filtering = selected_filtering;

    removeProductTiles();
    addPlaceholders();
    addMarketingBlocks(); // we might need them after clearing the filters

    // This request may already be in flight, started alongside the first one in loadCollection
    const prefetched = takePrefetchedRequest(
      requestSignature(selected_filtering, window.theme.collections.sorting, window.theme.collections.page)
    );

    if (prefetched !== null) {
      nosto_collection = await prefetched;
    } else {
      nosto_collection = (window.theme.api.nosto.collection.enabled === true && window.theme.api.nosto.collection.current_collection_enabled === true) ? await NostoCollectionsObj.nostoRequest() : await ShopifyCollectionObj.shopifyRequest();
    }
    // console.log('nosto_collection 1: ', nosto_collection);

    // null means the request errored or timed out. This path has already wiped the tiles and
    // re-injected placeholders, so bailing out silently would leave the grid empty for good.
    if (nosto_collection === null) {
      removePlaceholders();
      loadFailed();
      return;
    }
  }

  let nosto_products = [];

  if (typeof nosto_collection === 'undefined' || nosto_collection === null || typeof nosto_collection.products === 'undefined' || nosto_collection.products === null || nosto_collection.products.hits === null || nosto_collection.products.hits.length === 0) {
    // if (from_search) {
    //   filtered_products_search = [];
    // } else {
    filtered_products = [];
    // }

    refreshOptions(0);
    initNumberedPagination(nosto_nbHits_search, nosto_nbHits);
  } else {
    nosto_products = nosto_collection.products.hits;

    // Load the same products from the Storefront API
    // const unique_ids = _.uniq(nosto_products.map(hit => hit.id));
    // const storefrontapi_products = await loadProductsByID(unique_ids);

    // log('-- Total Storefront API products:', storefrontapi_products.length);
    // log('-- Total Nosto hits:', nosto_products.length);

    // filtered_products = mergeStorefrontAPIAndAlgoliaData(storefrontapi_products, nosto_products);
    if (from_search) {
      nosto_nbHits_search = nosto_collection.products.total;
    } else {
      nosto_nbHits = nosto_collection.products.total;
      refreshOptions(nosto_nbHits);
      initNumberedPagination(nosto_nbHits_search, nosto_nbHits);
    }
  }

  if (from_search) {
    filtered_products_search = nosto_products;
  } else {
    filtered_products = nosto_products;
  }

  const mobile_filter_nav = document.querySelector('[data-collection-grid-container] [data-show-mobile-filter-nav]');
  if (mobile_filter_nav) {
    mobile_filter_nav.classList.add('active');
  }

  const total_filtered_items = document.querySelectorAll(`[data-${prefix}total-filtered-items]`);
  if (total_filtered_items.length > 0) {
    total_filtered_items.forEach(el => el.classList.remove('hide'));
  }

  const c_filtered_products = (from_search) ? filtered_products_search : filtered_products;

  if (c_filtered_products.length) {
    // Show the correct amount of products
    if (is_save_filter_state === false && !from_search) {
      const load_page = getPaginationState();
      getNextSetOfProducts(true, load_page);
      current_page = load_page;
    } else {
      getNextSetOfProducts(true);
    }

    await buildProductTiles(false, from_search, 'filtering', 'filteringPerformed');
    showPagination();
  } else {
    noResults();
  }

  if (per_page > window.theme.collections.products_per_page) {
    current_page = per_page / window.theme.collections.products_per_page;
    per_page = window.theme.collections.products_per_page;
  }
};

/**
 * Request the new page data (From numbered pagination or load more)
 * Adds the products to the filtered_products variable
 *
 * @param {Boolean} regular_pagination - Numbered pagination if true; Load more if false
 *
 * @returns {Boolean} false if no Nosto products extracted. true otherwise
 * 
 */
const loadPageData = async (regular_pagination = false) => {
  console.log('[ASTR] loadPageData', regular_pagination);
  const from_search = document.body.classList.contains('has-overlay-search');

  // Empty the page
  const grid_container = (from_search) ? document.querySelector('[data-overlay-search-grid-container] .grid') : document.querySelector('[data-product-tiles] .grid');
  if (grid_container) {
    // grid_container.innerHTML = '';
    removeProductTiles();

    // Re-inject the placeholder while we're loading the new products
    addPlaceholders();

    // Re-inject the marketing blocks while we're loading the new products if needed (page 1, no sort, no filters, no color in url, not from search overlay...)
    // If the marketing blocks were already injected, and the conditions are met, we remove them
    addMarketingBlocks();
  }
  // Don't jump to the top while we're putting the user back where they were
  if (!isRestoringPlpScroll()) {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }

  const container_selector = from_search ? document.querySelector('[data-overlay-search-results]') : document.querySelector('[data-product-tiles]');
  if (container_selector) {
    const pagination_element = container_selector.querySelector('[data-pagination]');
    if (pagination_element) {
      pagination_element.classList.remove('disabled');
    }
  }

  // Extract the selected filter options
  const selected_filtering = retrieveSelectedFilters();
  if (from_search) {
    window.theme.search.filtering = selected_filtering;
  } else {
    window.theme.collections.filtering = selected_filtering;
  }

  /*
  // Load and add the next set of Algolia products to filtered_products
  const nosto_collection = await loadAlgoliaCollection(current_page - 1, selected_filtering);
  let nosto_products = [];

  if (nosto_collection === null || typeof nosto_collection.hits === 'undefined' || nosto_collection.hits.length === 0) {
    return false;
  }

  // Merge the cached data and the Algolia data if we received data from Algolia
  nosto_products = nosto_collection.hits;

  // Load the same products from the Storefront API
  const unique_ids = _.uniq(nosto_products.map(hit => hit.id));
  const storefrontapi_products = await loadProductsByID(unique_ids);

  const new_set_of_filtered_products = mergeStorefrontAPIAndAlgoliaData(storefrontapi_products, nosto_products);
  */

  const nosto_collection = (window.theme.api.nosto.collection.enabled === true && window.theme.api.nosto.collection.current_collection_enabled === true) ? await NostoCollectionsObj.nostoRequest() : await ShopifyCollectionObj.shopifyRequest();
  let nosto_products = [];
  // console.log('nosto_collection 3: ', nosto_collection);
  if (typeof nosto_collection === 'undefined' || nosto_collection === null || typeof nosto_collection.products === 'undefined' || nosto_collection.products === null || nosto_collection.products.hits === null || nosto_collection.products.hits.length === 0) {
    return false;
  }

  nosto_products = nosto_collection.products.hits;

  if (regular_pagination) {
    filtered_products_paginated = nosto_products;
    filtered_products = nosto_products;
  } else {
    filtered_products = filtered_products.concat(nosto_products);
  }

  // log('[ASTR] -- Total Storefront API products:', storefrontapi_products.length);
  log('[ASTR] -- Total Nosto hits in page:', nosto_products.length);
  log('[ASTR] -- Total filtered products:', filtered_products.length);

  if (!from_search) {
    recommendationListVisibility(selected_filtering);
  }

  return true;
};

/**
 * Init the events for some of the elements within the PLP
 */
const initEvents = () => {
  /*
  // Load more for PLP only (not search overlay)
  document.addEventListener('click', async (e) => {
    if (e.target.matches('[data-load-more]')) {
      e.preventDefault();
      e.stopPropagation();
      const item = e.target;

      if (item.classList.contains('loading')) {
        return;
      }

      const from_search = document.body.classList.contains('has-overlay-search');
      item.innerHTML = 'Loading...';
      item.classList.add('loading');
      current_page++;
      (from_search) ? window.theme.search.page = current_page : window.theme.collections.page = current_page;
      saveFilterState();

      window.trigger_on_more_page = true;

      await loadPageData();
      getNextSetOfProducts(false);
      buildProductTiles(true, false);

      if (filtered_products_paginated.length < per_page) {
        const load_more_button = document.querySelector('[data-load-more]');
        if (load_more_button) {
          load_more_button.classList.add('hide');
        }
      }

      // [ADA] Focus new element, do not place the focus to the main element, it would enable the add to cart / quickview button
      // const last_tile_index = per_page * (current_page - 1);
      // document.querySelectorAll('[data-product-tile] [data-product-tile-image]')[last_tile_index].focus();
    }
  });
  */

  /* ********************************************
  Numbered pagination PLP only (not search overlay)
  ******************************************** */
  // Helper function to handle pagination clicks
  const handlePaginationClick = async (item, pageChange, explicitPage = null) => {
    if (item.classList.contains('disabled')) {
      return;
    }

    const from_search = document.body.classList.contains('has-overlay-search');
    const previous_page = window.theme.collections.page;
    let new_page;
    if (explicitPage !== null) {
      new_page = explicitPage;
    } else {
      new_page = (from_search) ? window.theme.search.page + pageChange : window.theme.collections.page + pageChange;
    }
    const total_pages = Math.ceil(nosto_nbHits / per_page);
    new_page = Math.max(1, Math.min(new_page, total_pages));
    (from_search) ? window.theme.search.page = new_page : window.theme.collections.page = new_page;
    current_page = new_page;
    window.theme.collections.cursor_direction = (new_page >= previous_page) ? 'after' : 'before';
    // console.log('[ASTR] Pagination click, new page:', new_page, ' previous_page:', previous_page, ' total_pages:', total_pages, ' direction:', window.theme.collections.cursor_direction);

    updatePageInUrl(new_page);
    saveFilterState();
    await loadPageData(true);
    await buildProductTiles(false, false, 'pagination', 'paginationPerformed');
    initNumberedPagination(nosto_nbHits_search, nosto_nbHits);

    // [ADA] Focus new element
    document.querySelector('[data-product-tiles] [data-product-tile]')?.focus();
  };

  document.addEventListener('click', async (e) => {
    const target = e.target.closest('[data-pagination-first], [data-pagination-last], [data-pagination-next], [data-pagination-previous]');
    if (!target) return;

    e.preventDefault();

    if (target.matches('[data-pagination-first]')) {
      await handlePaginationClick(target, 0, 1);
    } else if (target.matches('[data-pagination-last]')) {
      const total_pages = Math.ceil(nosto_nbHits / per_page);
      await handlePaginationClick(target, 0, total_pages);
    } else if (target.matches('[data-pagination-next]')) {
      await handlePaginationClick(target, 1);
    } else if (target.matches('[data-pagination-previous]')) {
      await handlePaginationClick(target, -1);
    }

    window.localStorage.setItem('current-page', window.location.href);
  });

  // Retry after a failed products request
  document.addEventListener('click', async (e) => {
    if (!e.target.closest('[data-collection-retry]')) {
      return;
    }

    removeLoadFailed();
    addPlaceholders();
    await loadCollection();
  });

  document.addEventListener('pagination:page-click', async (e) => {
    const { page } = e.detail;
    if (!page) return;
    // Use a dummy element as the "item" — it has no disabled class so it always proceeds
    const dummy = document.createElement('button');
    await handlePaginationClick(dummy, 0, page);
    window.localStorage.setItem('current-page', window.location.href);
  });

  /*
  // Might not be the best place to add but this is for PLP and Search overlay
  document.addEventListener('click', (e) => {
    if (e.target.matches('[data-product-tile-image]')) {
      const item = e.target;
      const tile = item.closest('.product-tile');
      // algoliaSearchClickEvent([String(tile.dataset.productAlgoliaId)], [tile.closest('.product-tile').index() + 1]);
    }
  });
  */

  $(window).on('breakpointHasChanged', () => {
    // console.log('breakpointHasChanged addPaginationTileToLastRow', current_page, window.theme.collections.page);
    addPaginationTileToLastRow(nosto_nbHits, per_page);
  });
};

/**
 * Initialize the events and data for filtering
 */
const initFilteredCollection = async () => {
  try {
    // Validate and retrieve collection data
    const collection_grid = document.querySelector('[data-collection-grid]');
    if (!collection_grid) {
      throw new Error('Collection grid element not found.');
    }

    collection_handle = collection_grid.dataset.collection || '';
    collection_id = collection_grid.dataset.collectionId || '';

    if (!collection_handle || !collection_id) {
      throw new Error('Collection handle or ID is missing.');
    }

    // Initialize NostoCollections object
    if (window.theme.api.nosto.collection.enabled === true && window.theme.api.nosto.collection.current_collection_enabled === true) {
      NostoCollectionsObj = new NostoCollections(collection_id);
      if (!NostoCollectionsObj) {
        throw new Error('Failed to initialize NostoCollections.');
      }
    } else {
      ShopifyCollectionObj = new ShopifyCollection(collection_id, true);
      if (!ShopifyCollectionObj) {
        throw new Error('Failed to initialize ShopifyCollection.');
      }
    }

    // Initialize events and load collection data
    initEvents();
    await loadCollection();
  } catch (error) {
    console.error('[initFilteredCollection] Error initializing filtering:', error);
  }
};

export {
  initFilteredCollection,
  selectNewFilter,
  products_json,
  filtered_products,
  filtered_products_search,
  buildProductTiles,
  setFilteredProducts,
  setNextPageSearch,
  setNbHitsSearch,
  setCurrentPageSearch,
  getCurrentPageSearch,
  getCurrentPage,
  getNextSetOfProducts,
  per_page,
  loadCollection,
};
